import React, { ReactNode } from "react";
import { Col, Empty, Row, Typography } from "antd";

const { Title } = Typography;

interface OverviewSectionProps<T> {
  title: string;
  items?: T[];
  renderItem: (item: T, index: number) => ReactNode;
  emptyDescription: string;
}

export const OverviewSection = <T,>({
  title,
  items,
  renderItem,
  emptyDescription,
}: OverviewSectionProps<T>) => {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Title
        level={5}
        className="!mb-3 !mt-0 shrink-0 text-neutral-500 !text-2xl"
      >
        {title}
      </Title>
      <div className="min-h-0 flex-1 overflow-y-auto px-2 pb-2 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-button]:hidden [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 hover:[&::-webkit-scrollbar-thumb]:bg-neutral-400">
        {items?.length ? (
          <Row gutter={[16, 16]}>
            {items.map((item, index) => (
              <Col key={index} xs={24} sm={12} md={8} lg={4}>
                {renderItem(item, index)}
              </Col>
            ))}
          </Row>
        ) : (
          <Empty description={emptyDescription} />
        )}
      </div>
    </div>
  );
};
